module.exports = __webpack_public_path__ + "static/appstore-ba6650c54fbb3228dfe34cf21adc8212.jpg";